import { useQuery } from '@apollo/client';
import { Autocomplete, FormControl, TextField } from '@mui/material';
import { Organization } from 'models/organization';
import React, { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { getChildClinicsWithParentTemplate } from 'apollo/templates/user/query.graphql';
import { currentOrgVar } from 'apollo/reactive-variables/organization';

type DentistClinicFilterProps = {
    onClinicFilterChange: (_: React.SyntheticEvent, clinic: Organization | null) => void;
    selectedClinic?: Organization | null;
};

const DentistClinicFilter: FC<DentistClinicFilterProps> = ({
    onClinicFilterChange,
    selectedClinic,
}: DentistClinicFilterProps) => {
    const { t: translate } = useTranslation(['common', 'orders']);
    const currentOrganization = currentOrgVar();

    const { data: { childClinicsWithParent } = {}, loading } = useQuery(getChildClinicsWithParentTemplate, {
        notifyOnNetworkStatusChange: true,
        variables: { parentClinicId: currentOrganization?._id },
    });

    return (
        <Fragment>
            {!loading && (
                <FormControl fullWidth>
                    <Autocomplete
                        id="dentist-clinic-select"
                        options={childClinicsWithParent}
                        getOptionLabel={(clinic: Organization) => `${clinic.name || ''}`}
                        renderOption={(props, option: Organization) => (
                            <li {...{ ...props, key: option?._id }}>
                                {option.name} &nbsp;
                                {!option.parentClinicId && option.isMain ? (
                                    <i> ({translate('common:MAIN')})</i>
                                ) : undefined}
                            </li>
                        )}
                        isOptionEqualToValue={(option: Organization, value: Organization) => option?._id === value?._id}
                        value={(selectedClinic || { name: '' }) as Organization}
                        onChange={onClinicFilterChange}
                        renderInput={(params) => <TextField {...params} label={translate('common:CLINIC')} />}
                    />
                </FormControl>
            )}
        </Fragment>
    );
};

export default DentistClinicFilter;
